import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { oidcAuthApiRef } from './apis';

// Overrides @backstage/plugin-app's DefaultSignInPage (which hardcodes
// providers: ["guest"]) with our Keycloak OIDC provider card.
export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          auto
          providers={[
            {
              id: 'oidc',
              title: 'IDS SSO',
              message: 'Sign in with IDS SSO (Keycloak)',
              apiRef: oidcAuthApiRef,
            },
          ]}
        />
      ),
  },
});
